(function () {
  var KEY = 'sr_free_shipping';

  function markActive() {
    try { localStorage.setItem(KEY, '1'); } catch (e) {}
  }

  function isActive() {
    if (window.SR_FREE_SHIPPING === true) return true;
    try { return localStorage.getItem(KEY) === '1'; } catch (e) { return false; }
  }

  window.srHasFreeShipping = isActive;

  var params = new URLSearchParams(window.location.search);
  if (params.get('fri_frakt') === '1') {
    markActive();
    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ attributes: { fri_frakt: '1' } })
    }).catch(function () {});
  }
})();
